export default __webpack_public_path__ + "static/media/icon-info.f6653471.png";